import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  message: string;
  duration: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toastIdCounter = 0;
  toasts = signal<Toast[]>([]);

  show(message: string, duration = 3000): void {
    const id = ++this.toastIdCounter;
    const toast: Toast = { id, message, duration };
    
    this.toasts.update((current) => [...current, toast]);

    setTimeout(() => {
      this.dismiss(id);
    }, duration);
  }

  dismiss(id: number): void {
    this.toasts.update((current) => current.filter((t) => t.id !== id));
  }
}
